import { isNumber } from "@visactor/vutils";

export function isMergeCellGroup(cellGroup) {
    return !!("cell" === cellGroup.role && isNumber(cellGroup.mergeStartCol) && isNumber(cellGroup.mergeStartRow) && isNumber(cellGroup.mergeEndCol) && isNumber(cellGroup.mergeEndRow));
}
//# sourceMappingURL=is-merge-cell-group.js.map
